module.exports = __webpack_public_path__ + "img/badge-do-your-part-eat-smart.2dc771c1.png";